exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mp-payload[data-v-65fbc368] {\r\n    background: #f5f5f5;\r\n    padding: 1em;\r\n    border-radius: 4px;\r\n    max-height: 500px;\r\n    overflow: auto;\r\n    font-size: 0.9em;\n}\n.mt-4[data-v-65fbc368] { margin-top: 1.5em;\n}\n.review-note-display[data-v-65fbc368] {\r\n    word-break: break-word;\n}\r\n", ""]);

// exports
